import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import type {CustomActionID} from '../types';

/**
 * `isCustomActionEndpointUrlAccessible` request params
 * (what is used to send to server)
 */
export type IsCustomActionEndpointUrlAccessibleRequestOptions = {
	id: CustomActionID;
};

/**
 * `isCustomActionEndpointUrlAccessible` request
 * (what gets sent to the server)
 */
export type IsCustomActionEndpointUrlAccessibleRequest = [
	IsCustomActionEndpointUrlAccessibleRequestOptions['id'],
];

/**
 * `isCustomActionEndpointUrlAccessible` response
 * (what comes back from the server)
 */
export type IsCustomActionEndpointUrlAccessibleResponse =
	SuccessResponse<IsCustomActionEndpointUrlAccessibleResult>;

/**
 * `isCustomActionEndpointUrlAccessible` result
 * (what is utilized from the server response)
 */
export type IsCustomActionEndpointUrlAccessibleResult = boolean;

export const isCustomActionEndpointUrlAccessibleEndpoint =
	'isCustomActionEndpointUrlAccessible';

/**
 * Test custom action endpoint
 */
export const isCustomActionEndpointUrlAccessible = async (
	{id}: IsCustomActionEndpointUrlAccessibleRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: IsCustomActionEndpointUrlAccessibleRequest = [id];

	return client
		.post<IsCustomActionEndpointUrlAccessibleResponse>(
			isCustomActionEndpointUrlAccessibleEndpoint,
			requestParams,
			{signal},
		)
		.then((response) => response.data.result);
};

export default isCustomActionEndpointUrlAccessible;
